import { CalendarService } from '@services/CalendarService';

export interface ILoadedWorkCalendar {
    extraWorkingDays: Date[];
    extraHolidays: Date[];
    /** Названия праздников: ключ — getTime() локальной полуночи даты */
    holidayNames: Map<number, string>;
}

const EMPTY_CALENDAR: ILoadedWorkCalendar = {
    extraWorkingDays: [],
    extraHolidays: [],
    holidayNames: new Map(),
};

let calendarCache: Promise<ILoadedWorkCalendar> | null = null;

const prepareDate = (date: Date): Date => {
    const value = new Date(date);
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
};

/** Общая для hook- и resolver-слоёв загрузка рабочего календаря с одним кэшем запроса. */
export function loadWorkCalendar(): Promise<ILoadedWorkCalendar> {
    if (!calendarCache) {
        const pending: Promise<ILoadedWorkCalendar> = CalendarService.fetchCalendar()
            .then((response) => {
                const calendar = response.data.workTimeDays;
                const holidayNames = new Map<number, string>();
                (calendar.holidayNames ?? []).forEach(({ date, name }) => {
                    holidayNames.set(prepareDate(date).getTime(), name);
                });
                return {
                    extraWorkingDays: calendar.workingDays.map(prepareDate),
                    extraHolidays: calendar.holidays.map(prepareDate),
                    holidayNames,
                };
            })
            // Недоступность календаря не должна ломать RHF resolver или оставлять unhandled rejection.
            // В деградированном режиме действуют стандартные суббота/воскресенье, но кэш ошибки
            // сбрасываем — иначе разовый сбой сети навсегда оставил бы пустой календарь на всю сессию.
            .catch(() => {
                if (calendarCache === pending) calendarCache = null;
                return EMPTY_CALENDAR;
            });
        calendarCache = pending;
    }

    return calendarCache;
}

/** @internal Тестам: забыть загруженный календарь. */
export function resetWorkCalendarCache(): void {
    calendarCache = null;
}
